/*
 *
 * DashboardContainer actions
 *
 */
import {
  FETCH_GAMMA_TOKEN,
  UPDATE_GAMMA_TOKEN,
} from '../LandingPage/constants';

import {
  DEFAULT_ACTION,
  UPDATE_MENU_SELECTED,
  FETCH_PG_DASHBOARD_STATUS_DATA,
  UPDATE_PG_DASHBOARD_STATUS_DATA,
  ENABLE_LOADER,
  UPDATE_STATUS,
  FETCH_MERCHANT_DETAILS,
  SAVE_MERCHANT_DETAIL_RESPONSE,
  DISABLE_LOADER,
  UPDATE_PG_DASHBOARD_CONFIG,
  GET_SUBSCRIPTION_STATUS,
  UPDATE_SUBSCRIPTION_STATUS,
  COHORT_LIST_DATA,
  COHORT_LIST_DATA_SUCCESS,
  GET_MERCHANT_CHECKLIST_PREFERENCE,
  FETCH_MERCHANT_TRANSACTION_STATUS,
  UPDATE_LOADER_FOR_DASHBOARD,
  FETCH_REFLECT_SHAREABLE_LINK,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function updateMenuSelected(data) {
  return {
    type: UPDATE_MENU_SELECTED,
    data,
  };
}

export function fetchPGDashboardStatusData(data) {
  return {
    type: FETCH_PG_DASHBOARD_STATUS_DATA,
    data,
  };
}

export const fetchMerchantTransactionStatusAction = data => ({
  type: FETCH_MERCHANT_TRANSACTION_STATUS,
  data,
});

export function updateLoaderForDashboard(data) {
  return {
    type: UPDATE_LOADER_FOR_DASHBOARD,
    data,
  };
}

export function updatePGDashboardStatusData(data) {
  return {
    type: UPDATE_PG_DASHBOARD_STATUS_DATA,
    data,
  };
}

export function fetchMerchantDetailsAction() {
  return {
    type: FETCH_MERCHANT_DETAILS,
  };
}

export function saveMerchantDetailsResponseAction(data) {
  return {
    type: SAVE_MERCHANT_DETAIL_RESPONSE,
    data,
  };
}

export function enableLoader() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoader() {
  return {
    type: DISABLE_LOADER,
  };
}

export function updateStatus(data) {
  return {
    type: UPDATE_STATUS,
    data,
  };
}

export function updatePGDashboardConfigAction(data) {
  return {
    type: UPDATE_PG_DASHBOARD_CONFIG,
    data,
  };
}

export function getSubscriptionStatusAction() {
  return {
    type: GET_SUBSCRIPTION_STATUS,
  };
}

export function updateSubscriptionStatus(data) {
  return {
    type: UPDATE_SUBSCRIPTION_STATUS,
    data,
  };
}

export function fetchCohortListData() {
  return {
    type: COHORT_LIST_DATA,
  };
}

export function fetchCohortListDataSuccess(cohortList) {
  return {
    type: COHORT_LIST_DATA_SUCCESS,
    payload: cohortList,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getMerchantChecklistPreferenceAction(data) {
  return {
    type: GET_MERCHANT_CHECKLIST_PREFERENCE,
    data,
  };
}

export function fetchGammaTokenAction(data) {
  return {
    type: FETCH_GAMMA_TOKEN,
    data,
  };
}
export function updateGammaToken(data) {
  return {
    type: UPDATE_GAMMA_TOKEN,
    data,
  };
}

export const fetchReflectShareableUrlAction = data => ({
  type: FETCH_REFLECT_SHAREABLE_LINK,
  data,
});
